import { createTextMask, createNumberMask } from 'redux-form-input-masks';
import formatStringByPattern from 'format-string-by-pattern';

export function cpfMasker() {
  return createTextMask({ pattern: '999.999.999-99' });
}

export function cnpjMasker() {
  return createTextMask({ pattern: '99.999.999/9999-99' });
}

export function cellPhoneMasker() {
  return createTextMask({ pattern: '(99) 99999-9999' });
}

export function phoneMasker() {
  return createTextMask({ pattern: '(99) 9999-9999' });
}

export function cepMasker() {
  return createTextMask({ pattern: '99999-999' });
}

export function currencyMasker() {
  return createNumberMask({ prefix: 'R$ ', decimalPlaces: 2, locale: 'pt-BR' });
}

export function agencyMasker(pattern) {
  if (typeof pattern === 'undefined') {
    return createTextMask({ pattern: '9999' });
  }
  return createTextMask({ pattern });
}

export function accountMasker(pattern) {
  if (typeof pattern === 'undefined') {
    return createTextMask({ pattern: '9999' });
  }
  return createTextMask({ pattern });
}

export function percentageMasker() {
  return createNumberMask({
    suffix: '%',
    decimalPlaces: 2,
    decimalSeparator: ',',
    locale: 'pt-BR',
  });
}

export function twoDecimalPlaces() {
  return createNumberMask({
    decimalPlaces: 2,
    locale: 'pt-BR',
  });
}

export function threeDecimalPlaces() {
  return createNumberMask({
    decimalPlaces: 3,
    suffix: 'Kg',
  });
}

export function onlyNumbersFormatString(value, pattern) {
  const onlyNumbers = value.replace(/[^\d]/g, '');
  return formatStringByPattern(pattern, onlyNumbers);
}
